/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListIconAsset } from '../../models/api-response-list-icon-asset';

export interface GetActiveIcons$Params {
}

export function getActiveIcons(http: HttpClient, rootUrl: string, params?: GetActiveIcons$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListIconAsset>> {
  const rb = new RequestBuilder(rootUrl, getActiveIcons.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListIconAsset>;
    })
  );
}

getActiveIcons.PATH = '/v1/api/icon-asset-client/list';
